import React, { useState, useEffect } from 'react';
import './NewProduct.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';

export default function NewProduct() {

    const [mensaje, setMensaje] = useState('');
    const [imagenPreview1, setImagenPreview1] = useState(null);
    const [imagenPreview2, setImagenPreview2] = useState(null);
    const [imagenPreview3, setImagenPreview3] = useState(null);
    const [imagenPreview4, setImagenPreview4] = useState(null);
    const [imagenPreview5, setImagenPreview5] = useState(null);
    const [descripcion, setDescripcion] = useState('');
    const [titulo, setTitulo] = useState('');
    const [categoria, setCategoria] = useState('');
    const [masVendido, setMasVendido] = useState('');
    const [precio, setPrecio] = useState('');
    const [isImage1Selected, setIsImage1Selected] = useState(false);
    const [isImage2Selected, setIsImage2Selected] = useState(false);
    const [isImage3Selected, setIsImage3Selected] = useState(false);
    const [isImage4Selected, setIsImage4Selected] = useState(false);
    const [isImage5Selected, setIsImage5Selected] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [categorias, setCategoras] = useState([]);
    const [item1, setItem1] = useState('');
    const [item2, setItem2] = useState('');
    const [item3, setItem3] = useState('');
    const [item4, setItem4] = useState('');
    const [item5, setItem5] = useState('');
    const [item6, setItem6] = useState('');
    const [item7, setItem7] = useState('');
    const [item8, setItem8] = useState('');
    const [item9, setItem9] = useState('');
    const [item10, setItem10] = useState('');
    const [precioAnterior, setPrecioAnterior] = useState('');
    const [stock, setStock] = useState('');
    const [kilometros, setKilometros] = useState('');
    const [anio, setAnio] = useState('');
    const [transmision, setTransmision] = useState('');
    const [combustible, setCombustible] = useState('');
    const [modelo, setModelo] = useState('');
    const [marcas, setMarcas] = useState([]);
    const [marcaSeleccionada, setMarcaSeleccionada] = useState(''); // Estado para la marca seleccionada
    // *** NUEVO ESTADO PARA EL FILTRO DE MARCAS ***
    const [filtroMarca, setFiltroMarca] = useState('');

    const [engine, setEngine] = useState('');
    const [width, setWidth] = useState('');
    const [cooling, setCooling] = useState('');
    const [height, setHeight] = useState('');
    const [fuel, setFuel] = useState('');
    const [seatHeight, setSeatHeight] = useState('');
    const [displacement, setDisplacement] = useState('');
    const [frontWheel, setFrontWheel] = useState('');
    const [maxPower, setMaxPower] = useState('');
    const [rearWheel, setRearWheel] = useState('');
    const [maxSpeed, setMaxSpeed] = useState('');
    const [frontBrake, setFrontBrake] = useState('');
    const [rearBrake, setRearBrake] = useState('');
    const [starter, setStarter] = useState('');
    const [tank, setTank] = useState('');
    const [weight, setWeight] = useState('');
    const [alarm, setAlarm] = useState('');
    const [length, setLength] = useState('');
    const [warranty, setWarranty] = useState('');
    const [isMotorcycle, setIsMotorcycle] = useState(false);

    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };
    const handleImagenChange = (event, setImagenPreview, setIsImageSelected) => {
        const file = event.target.files[0];

        if (file) {
            const previewURL = URL.createObjectURL(file);
            setImagenPreview(previewURL);
            setIsImageSelected(true);
        }
    };

    const crear = async () => {
        const form = document.getElementById("crearForm");
        const formData = new FormData(form);
        formData.append('isMotorcycle', Number(isMotorcycle));
        const resetForm = () => {
            form.reset();
            setImagenPreview1(null);
            setImagenPreview2(null);
            setImagenPreview3(null);
            setImagenPreview4(null); // Resetear las previsualizaciones restantes
            setImagenPreview5(null);
            setDescripcion('');
            setTitulo('');
            setCategoria('');
            setMasVendido('');
            setPrecio('');
            setItem1('');
            setItem2('');
            setItem3('');
            setItem4('');
            setItem5('');
            setItem6('');
            setItem7('');
            setItem8('');
            setItem9('');
            setItem10('');
            setPrecioAnterior('');
            setStock('');
            setKilometros('');
            setAnio('');
            setTransmision('');
            setCombustible('');
            setModelo('');
            setMarcaSeleccionada('');
            setFiltroMarca(''); // Reiniciar el filtro
            setIsImage1Selected(false);
            setIsImage2Selected(false);
            setIsImage3Selected(false);
            setIsImage4Selected(false);
            setIsImage5Selected(false);
            setEngine('');
            setWidth('');
            setCooling('');
            setHeight('');
            setFuel('');
            setSeatHeight('');
            setDisplacement('');
            setFrontWheel('');
            setMaxPower('');
            setRearWheel('');
            setMaxSpeed('');
            setFrontBrake('');
            setRearBrake('');
            setStarter('');
            setTank('');
            setWeight('');
            setAlarm('');
            setLength('');
            setWarranty('');
            setIsMotorcycle(0);
        };
        setMensaje('');

        if (
            !formData.get('titulo') ||
            !formData.get('idCategoria') ||
            !formData.get('masVendido') ||
            !formData.get('precio') ||
            !formData.get('imagen1') ||
            !formData.get('imagen2') ||
            !formData.get('imagen3') ||
            !formData.get('imagen4') ||
            !formData.get('imagen5') ||
            !formData.get('anio') ||
            !formData.get('transmision') ||
            !formData.get('combustible') ||
            !formData.get('idMarca')
        ) {
            toast.error('Por favor, complete todos los campos obligatorios.');
            return;
        }

        setMensaje('Procesando...');

        try {
            const response = await fetch(`${baseURL}/productosPost.php`, {
                method: 'POST',
                body: formData
            });

            const data = await response.json();

            if (data.mensaje) {
                setMensaje('');
                resetForm();
                toast.success(data.mensaje);
                // No recargar toda la ventana si no es estrictamente necesario,
                // un reset de formulario y un mensaje de éxito suelen ser suficientes.
                // window.location.reload(); 
            } else if (data.error) {
                setMensaje('');
                toast.error(data.error);
                console.log(data.error);

            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            toast.error('Error de conexión. Por favor, inténtelo de nuevo.');

        }
    };


    const handleCategoriaChange = (e) => {
        setCategoria(e.target.value);
    };

    // La marca se selecciona con el select, pero ahora el input de filtro no afecta la seleccion final
    const handleMarcaChange = (e) => {
        setMarcaSeleccionada(e.target.value);
    };

    // *** NUEVA FUNCIÓN PARA MANEJAR EL CAMBIO EN EL CAMPO DE FILTRO ***
    const handleFiltroMarcaChange = (e) => {
        setFiltroMarca(e.target.value);
    };

    const handleMasVendidoChange = (e) => {
        setMasVendido(e.target.value);
    };
    const handleStock = (e) => {
        setStock(e.target.value);
    };
    useEffect(() => {
        cargarCategoria();
        cargarMarcas();
    }, []);


    const cargarCategoria = () => {
        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategoras(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const cargarMarcas = () => {
        fetch(`${baseURL}/marcasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setMarcas(data.marca || []);
            })
            .catch(error => console.error('Error al cargar marcas:', error));
    };

    // *** LÓGICA DE FILTRADO ***
    const marcasFiltradas = marcas.filter(item =>
        item.nombre.toLowerCase().includes(filtroMarca.toLowerCase())
    );

    return (
        <div className='NewContain'>
            <ToastContainer />
            <button onClick={toggleModal} className='btnSave'>
                <span>  +</span> Agregar
            </button>
            {modalOpen && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>Agregar Producto</button>
                            <span className="close" onClick={toggleModal}>&times;</span>
                        </div>
                        <form id="crearForm">

                            <div className='flexGrap'>
                                {/* ... Otros fieldsets ... */}


                                {/* ... El resto de tus fieldsets ... */}
                                <fieldset>
                                    <legend>Título/Modelo (obligatorio)</legend>
                                    <input
                                        type="text"
                                        id="titulo"
                                        name="titulo"
                                        required
                                        value={titulo}
                                        onChange={(e) => setTitulo(e.target.value)}
                                    />
                                </fieldset>

                                {/* CAMPO DE SELECCIÓN DE MARCA MEJORADO */}
                                <fieldset>
                                    <legend>Marca (obligatorio) <span style={{ fontSize: '0.8em', color: '#666' }}>({marcasFiltradas.length} encontradas)</span></legend>

                                    {/* CAMPO DE TEXTO PARA FILTRAR */}
                                    <input
                                        type="text"
                                        placeholder="Escribe para filtrar marcas..."
                                        value={filtroMarca}
                                        onChange={handleFiltroMarcaChange}
                                        style={{ marginBottom: '8px', padding: '8px', width: '100%', boxSizing: 'border-box' }}
                                    />

                                    {/* SELECT CON LAS MARCAS FILTRADAS */}
                                    <select
                                        id="idMarca"
                                        name="idMarca"
                                        value={marcaSeleccionada}
                                        onChange={handleMarcaChange}
                                        required // Aseguramos que se seleccione una
                                        // Estilo opcional para destacar que la lista se está filtrando
                                        style={{ backgroundColor: filtroMarca ? '#f0f8ff' : 'white' }}
                                    >
                                        <option value="">Selecciona una marca</option>

                                        {/* Mapeamos la lista FILTRADA */}
                                        {marcasFiltradas.map(item => (
                                            <option key={item.idMarca} value={item.idMarca}>
                                                {item.nombre}
                                            </option>
                                        ))}
                                    </select>
                                </fieldset>
                                <fieldset>
                                    <legend>Precio (obligatorio)</legend>
                                    <input
                                        type="number"
                                        id="precio"
                                        name="precio"
                                        min="0"
                                        step="0.01"
                                        required
                                        value={precio}
                                        onChange={(e) => setPrecio(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Categoría (obligatorio)</legend>
                                    <select
                                        id="idCategoria"
                                        name="idCategoria"
                                        value={categoria}
                                        onChange={handleCategoriaChange}
                                    >
                                        <option value="">Selecciona una categoría</option>
                                        {categorias.map(item => (
                                            <option key={item.idCategoria} value={item.idCategoria}>{item.categoria}</option>
                                        ))}
                                    </select>
                                </fieldset>

                                <fieldset>
                                    <legend>Destacados (obligatorio)</legend>
                                    <select
                                        id="masVendido"
                                        name="masVendido"
                                        value={masVendido}
                                        onChange={handleMasVendidoChange}
                                    >
                                        <option value="">Selecciona opcion</option>
                                        <option value="si">Si</option>
                                        <option value="no">No</option>

                                    </select>
                                </fieldset>
                                <fieldset>
                                    <legend>Stock (obligatorio)</legend>
                                    <input
                                        type="number"
                                        id="stock"
                                        name="stock"
                                        min="0"
                                        step="0.01"
                                        required
                                        value={stock}
                                        onChange={(e) => setStock(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Kilometros</legend>
                                    <input
                                        type="number"
                                        id="kilometros"
                                        name="kilometros"
                                        min="0"
                                        step="0.01"
                                        required
                                        value={kilometros}
                                        onChange={(e) => setKilometros(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Año (obligatorio)</legend>
                                    <input
                                        type="number"
                                        id="anio"
                                        name="anio"
                                        min="0"
                                        step="1.0"
                                        required
                                        value={anio}
                                        onChange={(e) => setAnio(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Transmission</legend>
                                    <select
                                        id="transmision"
                                        name="transmision"
                                        value={transmision}
                                        onChange={(e) => setTransmision(e.target.value)}
                                    >
                                        <option value="">Selecciona Transmisión</option>
                                        <option value="4-speed-Manual">Manual 4 velocidades</option>
                                        <option value="5-speed-Manual">Manual 5 velocidades</option>
                                        <option value="automatic">Automática</option>

                                    </select>
                                </fieldset>

                                <fieldset>
                                    <legend>Combustible (obligatorio)</legend>
                                    <select
                                        id="combustible"
                                        name="combustible"
                                        value={combustible}
                                        onChange={(e) => setCombustible(e.target.value)}
                                    >
                                        <option value="">Selecciona opcion</option>
                                        <option value="nafta">Nafta</option>
                                        <option value="gnc">GNC</option>
                                        <option value="diesel">Diesel</option>
                                        <option value="nafta/gnc">Nafta/GNC</option>
                                    </select>
                                </fieldset>

                                <fieldset>
                                    <legend>Motor</legend>
                                    <input
                                        type="text"
                                        id="engine"
                                        name="engine"
                                        value={engine}
                                        onChange={(e) => setEngine(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Ancho(mm)</legend>
                                    <input
                                        type="number"
                                        id="width"
                                        name="width"
                                        value={width}
                                        onChange={(e) => setWidth(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Enfriamiento</legend>
                                    <input
                                        type="text"
                                        id="cooling"
                                        name="cooling"
                                        value={cooling}
                                        onChange={(e) => setCooling(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Altura(mm)</legend>
                                    <input
                                        type="number"
                                        id="height"
                                        name="height"
                                        value={height}
                                        onChange={(e) => setHeight(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Combustible</legend>
                                    <input
                                        type="text"
                                        id="fuel"
                                        name="fuel"
                                        value={fuel}
                                        onChange={(e) => setFuel(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Altura del asiento(mm)</legend>
                                    <input
                                        type="number"
                                        id="seatHeight"
                                        name="seatHeight"
                                        value={seatHeight}
                                        onChange={(e) => setSeatHeight(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Desplazamiento(cc)</legend>
                                    <input
                                        type="number"
                                        id="displacement"
                                        name="displacement"
                                        value={displacement}
                                        onChange={(e) => setDisplacement(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Rueda delantera</legend>
                                    <input
                                        type="text"
                                        id="frontWheel"
                                        name="frontWheel"
                                        value={frontWheel}
                                        onChange={(e) => setFrontWheel(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Máxima potencia</legend>
                                    <input
                                        type="text"
                                        id="maxPower"
                                        name="maxPower"
                                        value={maxPower}
                                        onChange={(e) => setMaxPower(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Rueda trasera</legend>
                                    <input
                                        type="text"
                                        id="rearWheel"
                                        name="rearWheel"
                                        value={rearWheel}
                                        onChange={(e) => setRearWheel(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Velocidad máxima(km/h)</legend>
                                    <input
                                        type="number"
                                        id="maxSpeed"
                                        name="maxSpeed"
                                        value={maxSpeed}
                                        onChange={(e) => setMaxSpeed(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Freno delantero</legend>
                                    <input
                                        type="text"
                                        id="frontBrake"
                                        name="frontBrake"
                                        value={frontBrake}
                                        onChange={(e) => setFrontBrake(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Freno trasero</legend>
                                    <input
                                        type="text"
                                        id="rearBrake"
                                        name="rearBrake"
                                        value={rearBrake}
                                        onChange={(e) => setRearBrake(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Arrancadora</legend>
                                    <select
                                        id="starter"
                                        name="starter"
                                        value={starter}
                                        onChange={(e) => setStarter(e.target.value)}
                                    >
                                        <option value="">Selecciona Arrancadora</option>
                                        <option value="electric">Eléctrica</option>
                                        <option value="kick">Patada</option>
                                        <option value="electric-and-kick">Eléctrico y patada</option>
                                    </select>
                                </fieldset>

                                <fieldset>
                                    <legend>Tanque(L)</legend>
                                    <input
                                        type="number"
                                        id="tank"
                                        name="tank"
                                        value={tank}
                                        onChange={(e) => setTank(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Peso(kg)</legend>
                                    <input
                                        type="number"
                                        id="weight"
                                        name="weight"
                                        value={weight}
                                        onChange={(e) => setWeight(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Alarma</legend>
                                    <input
                                        type="text"
                                        id="alarm"
                                        name="alarm"
                                        value={alarm}
                                        onChange={(e) => setAlarm(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Longitud(mm)</legend>
                                    <input
                                        type="number"
                                        id="length"
                                        name="length"
                                        value={length}
                                        onChange={(e) => setLength(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Garantía</legend>
                                    <input
                                        type="number"
                                        id="warranty"
                                        name="warranty"
                                        value={warranty}
                                        onChange={(e) => setWarranty(e.target.value)}
                                    />
                                </fieldset>

                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    width: '49%'
                                }}>
                                    <legend>Especificar motocicleta:</legend>
                                    <input
                                        type="checkbox"
                                        id="isMotorcycle"
                                        value={isMotorcycle}
                                        onChange={(e) => setIsMotorcycle(e.target.checked)}
                                    />
                                </div>


                                <fieldset id='descripcion'>
                                    <legend>Descripción</legend>
                                    <textarea
                                        id="descripcion"
                                        name="descripcion"
                                        required
                                        value={descripcion}
                                        onChange={(e) => setDescripcion(e.target.value)}
                                        placeholder="Descripción"
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Precio anterior</legend>
                                    <input
                                        type="number"
                                        id="precioAnterior"
                                        name="precioAnterior"
                                        min="0"
                                        step="0.01"
                                        required
                                        value={precioAnterior}
                                        onChange={(e) => setPrecioAnterior(e.target.value)}
                                    />
                                </fieldset>
                                <div className='items'>
                                    <fieldset>
                                        <legend>Item 1</legend>
                                        <input
                                            type="text"
                                            id="item1"
                                            name="item1"
                                            required
                                            value={item1}
                                            onChange={(e) => setItem1(e.target.value)}
                                        />
                                    </fieldset>

                                    <fieldset>
                                        <legend>Item 2</legend>
                                        <input
                                            type="text"
                                            id="item2"
                                            name="item2"
                                            required
                                            value={item2}
                                            onChange={(e) => setItem2(e.target.value)}
                                        />
                                    </fieldset>

                                    <fieldset>
                                        <legend>Item 3</legend>
                                        <input
                                            type="text"
                                            id="item3"
                                            name="item3"
                                            required
                                            value={item3}
                                            onChange={(e) => setItem3(e.target.value)}
                                        />
                                    </fieldset>

                                    <fieldset>
                                        <legend>Item 4</legend>
                                        <input
                                            type="text"
                                            id="item4"
                                            name="item4"
                                            required
                                            value={item4}
                                            onChange={(e) => setItem4(e.target.value)}
                                        />
                                    </fieldset>

                                    <fieldset>
                                        <legend>Item 5</legend>
                                        <input
                                            type="text"
                                            id="item5"
                                            name="item5"
                                            required
                                            value={item5}
                                            onChange={(e) => setItem5(e.target.value)}
                                        />
                                    </fieldset>

                                    <fieldset>
                                        <legend>Item 6</legend>
                                        <input
                                            type="text"
                                            id="item6"
                                            name="item6"
                                            required
                                            value={item6}
                                            onChange={(e) => setItem6(e.target.value)}
                                        />
                                    </fieldset>

                                    <fieldset>
                                        <legend>Item 7</legend>
                                        <input
                                            type="text"
                                            id="item7"
                                            name="item7"
                                            required
                                            value={item7}
                                            onChange={(e) => setItem7(e.target.value)}
                                        />
                                    </fieldset>

                                    <fieldset>
                                        <legend>Item 8</legend>
                                        <input
                                            type="text"
                                            id="item8"
                                            name="item8"
                                            required
                                            value={item8}
                                            onChange={(e) => setItem8(e.target.value)}
                                        />
                                    </fieldset>

                                    <fieldset>
                                        <legend>Item 9</legend>
                                        <input
                                            type="text"
                                            id="item9"
                                            name="item9"
                                            required
                                            value={item9}
                                            onChange={(e) => setItem9(e.target.value)}
                                        />
                                    </fieldset>

                                    <fieldset>
                                        <legend>Item 10</legend>
                                        <input
                                            type="text"
                                            id="item10"
                                            name="item10"
                                            required
                                            value={item10}
                                            onChange={(e) => setItem10(e.target.value)}
                                        />
                                    </fieldset>



                                </div>




                                <fieldset>
                                    <legend>Imagen1</legend>
                                    <input
                                        type="file"
                                        id="imagen1"
                                        name="imagen1"
                                        accept="image/*"
                                        onChange={(e) => handleImagenChange(e, setImagenPreview1, setIsImage1Selected)}
                                        required
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Imagen2</legend>
                                    <input
                                        type="file"
                                        id="imagen2"
                                        name="imagen2"
                                        accept="image/*"
                                        onChange={(e) => handleImagenChange(e, setImagenPreview2, setIsImage2Selected)}
                                        required
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Imagen3</legend>
                                    <input
                                        type="file"
                                        id="imagen3"
                                        name="imagen3"
                                        accept="image/*"
                                        onChange={(e) => handleImagenChange(e, setImagenPreview3, setIsImage3Selected)}
                                        required
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Imagen4</legend>

                                    <input
                                        type="file"
                                        id="imagen4"
                                        name="imagen4"
                                        accept="image/*"
                                        onChange={(e) => handleImagenChange(e, setImagenPreview4, setIsImage4Selected)}
                                        required
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Imagen5</legend>

                                    <input
                                        type="file"
                                        id="imagen5"
                                        name="imagen5"
                                        accept="image/*"
                                        onChange={(e) => handleImagenChange(e, setImagenPreview5, setIsImage5Selected)}
                                        required
                                    />
                                </fieldset>

                            </div>
                            {(isImage1Selected || isImage2Selected || isImage3Selected || isImage4Selected || isImage5Selected) &&
                                <div className='previevCategori'>
                                    {isImage1Selected && <img src={imagenPreview1} alt="Vista previa 1" />}
                                    {isImage2Selected && <img src={imagenPreview2} alt="Vista previa 2" />}
                                    {isImage3Selected && <img src={imagenPreview3} alt="Vista previa 3" />}
                                    {isImage4Selected && <img src={imagenPreview4} alt="Vista previa 4" />}
                                    {isImage5Selected && <img src={imagenPreview5} alt="Vista previa 5" />}
                                </div>
                            }
                            {mensaje ? (
                                <button type="button" className='btnLoading' disabled>
                                    {mensaje}
                                </button>
                            ) : (
                                <button type="button" onClick={crear} className='btnPost'>
                                    Agregar
                                </button>
                            )}


                        </form>
                    </div>
                </div>
            )}

        </div>
    );
}